import { Button, Grid, IconButton, MenuItem, Select } from "@mui/material";
import { useCallback, useState } from "react";
import { FilterItem } from "../users/UserFilters";
import DeleteIcon from '@mui/icons-material/Delete';
import { DayPicker } from "react-day-picker";
import dayjs from "dayjs";

export interface PointHistoryFilterData {
  filters: Array<{
    field: string;
    operator: string;
    value: string
  }>;
  operator: 'OR' | 'AND';
}

export const PointHistoryFilter: React.FC<any> = (props: any): JSX.Element => {
  const [filterItems, setFilterItems] = useState<Array<FilterItem>>([]);
  const [operator, setOperator] = useState<'AND' | 'OR'>('AND');
  const handleFilter = useCallback((event: any) => {
    const nonEmptyFilters = filterItems.filter((filter) => filter.field !== '');
    setFilterItems([
      ...nonEmptyFilters
    ]);
    props.onFilter({
      filters: [
        ...nonEmptyFilters.filter((filter) => filter.type !== 'DateTime').map((item) => ({
          field: item.field,
          operator: item.operator,
          value: `${(typeof item.value === 'object' && !(item.value instanceof Date) && !(Array.isArray(item.value))) ? item.value.name : item.value}`
        })),
        ...(nonEmptyFilters.filter((item) => item.type === 'DateTime').map((item) => [
          {
            field: item.field,
            operator: 'gte',
            value: dayjs((item.value as any)[0]).startOf('day').toDate().toISOString(),
          },
          {
            field: item.field,
            operator: 'lte',
            value: dayjs((item.value as any)[1]).endOf('day').toDate().toISOString(),
          }
        ])).flat()
      ],
      operator,
    });
  }, [filterItems, operator, props]);

  const addEmptyCondition = useCallback((event: any) => {
    event.preventDefault();
    setFilterItems([
      ...filterItems,
      { field: '', operator: 'equals', value: '', type: '', kind: '' },
    ])
  }, [filterItems]);

  const updateFilterItem = useCallback((item: FilterItem, index: number) => {
    filterItems[index] = item;
    setFilterItems([
      ...filterItems,
    ]);
  }, [filterItems]);

  const fields = [
    {
      name: 'type',
      type: 'String',
      kind: 'scalar',
    },
    {
      name: 'createdAt',
      type: 'DateTime',
      kind: 'scalar',
    }
  ];

  const deleteFilterItem = useCallback((index: number) => {
    setFilterItems(filterItems.filter((value, i) => i !== index));
  }, [filterItems]);
  return (
    <div>
      <Button onClick={addEmptyCondition}>Add new condition</Button>
      {filterItems.map((item, index) => (
        <div key={`item-${index}-${item.field}`}>
          <Grid container>
            <Grid item xs={2}>
              <Select
                value={item.field}
                onChange={(event: any) => {
                  updateFilterItem({
                    ...item,
                    field: event.target.value,
                    type: fields.find((field: any) => field.name === event.target.value)?.type ?? '',
                    kind: fields.find((field: any) => field.name === event.target.value)?.kind ?? '',
                  }, index);
                }}
              >
                {fields.filter((field: any) => !field.isReference).map((field: any) => (<MenuItem key={field.name} value={field.name}>{field.name}</MenuItem>))}
              </Select>
            </Grid>
            <Grid item xs={2}>
              <Select
                value={item.operator}
                onChange={(event: any) => {
                  updateFilterItem({
                    ...item,
                    operator: event.target.value,
                  }, index);
                }}
              >
                <MenuItem value={'equals'}>equals</MenuItem>
                {/* {item.type === 'DateTime' && (<MenuItem value={'lte'}>less than equal</MenuItem>)}
                {item.type === 'DateTime' && (<MenuItem value={'gte'}>greater than equal</MenuItem>)} */}
              </Select>
            </Grid>
            <Grid item xs={7}>
              {((item.field === 'type')) && (
                <Select
                  value={item.value}
                  onChange={(event: any) => {
                    updateFilterItem({
                      ...item,
                      value: event.target.value,
                    }, index);
                  }}
                >
                  <MenuItem value={'login'}>login</MenuItem>
                  <MenuItem value={'7_day_streak'}>7_day_streak</MenuItem>
                  <MenuItem value={'30_day_streak'}>30_day_streak</MenuItem>
                  <MenuItem value={'referred_with_recommendation'}>referred_with_recommendation</MenuItem>
                  <MenuItem value={'referred_users'}>referred_users</MenuItem>
                </Select>
              )}
              {item.type === 'DateTime' && (
                <div>
                  <Button variant="contained">
                    {item.value && (<span>{item.value ? dayjs((item.value as any)[0]).format('YYYY-MM-DD') : ''}</span>)}
                    {item.value && (<span>- {item.value ? dayjs((item.value as any)[1]).format('YYYY-MM-DD') : ''}</span>)}
                  </Button>
                  <DayPicker mode="range" selected={{
                    from: (item.value as any)[0],
                    to: (item.value as any)[1],
                  }}
                    onSelect={(value) => {
                      if (!value || !value.from || !value.to) {
                        return;
                      }
                      updateFilterItem({
                        ...item,
                        value: [dayjs(value.from).startOf('day').toDate(), dayjs(value.to).endOf('day').toDate()],
                      }, index);
                    }}
                  />
                </div>
                // <DatePicker onChange={(value) => {
                //   updateFilterItem({
                //     ...item,
                //     value: value?.toDate() ?? new Date(),
                //   }, index);
                // }} />
              )}
            </Grid>
            <Grid item xs={1}>
              <IconButton aria-label="delete" onClick={() => deleteFilterItem(index)}>
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
        </div>
      ))}
      <div>
        Operator among conditions:
        <Select
          value={operator}
          onChange={(event: any) => setOperator(event.target.value)}
        >
          <MenuItem value={'AND'}>AND</MenuItem>
          <MenuItem value={'OR'}>OR</MenuItem>
        </Select>
      </div>
      <div>
        <Button variant="contained" onClick={handleFilter}>Filter</Button>
      </div>
    </div>
  );
}